<template>
  <div :class="$style.container" />
</template>

<script setup></script>

<style module lang="scss">
@forward './ProductDetailSection.scss';
</style>
